import React from "react";
import { Button } from "react-bootstrap";
import FormatDataService from "../../../../../services/util/FormatData";

export default function ButtonHandle(props) {

    const dataInicialDDMMYYYY = FormatDataService.formatarDataParaDDMMYYYY(props.dataInicial);
    const dataFinalDDMMYYYY = FormatDataService.formatarDataParaDDMMYYYY(props.dataFinal);

    return (
        <>
            {props.buttonHandle === "comparativoDeCustoPlanejado" && (
                <Button
                    onClick={() =>
                        props.handleDados(
                            props.projetosSelecionados,
                            dataInicialDDMMYYYY,
                            dataFinalDDMMYYYY,
                            props.radioPeriodo
                        )}
                >
                    Gerar
                </Button>
            )}

            {props.buttonHandle === "comparativoDeFaturamento" && (
                <Button
                    onClick={() =>
                        props.handleDados(
                            props.projetosSelecionados,
                            dataInicialDDMMYYYY,
                            dataFinalDDMMYYYY,
                            props.radioPeriodo
                        )}
                >
                    Gerar
                </Button>
            )}

            {props.buttonHandle === "historicoCustoDeCliente" && (
                <Button
                    onClick={() =>
                        props.handleDados(
                            props.projetosSelecionados,
                            props.radioFiltrarPor,
                            props.dataInicial,
                            props.dataFinal,
                            props.tipoCusto,
                            props.clienteSelecionado,
                            props.liderSelecionado
                        )}
                >
                    Gerar
                </Button>
            )}

            {props.buttonHandle === "relatorioCapacidadeArea" && (
                <Button
                    onClick={() =>
                        props.handleDados(
                            props.dataInicial,
                            props.dataFinal,

                        )}
                >
                    Gerar
                </Button>
            )}

            {props.buttonHandle === "resultadoDoProjeto" && (
                <Button
                    onClick={() =>
                        props.handleDados(
                            props.projetosSelecionados,
                            props.radioPeriodo,
                            props.dataInicial,
                            props.dataFinal
                        )}
                >
                    Gerar
                </Button>
            )}

            {props.buttonHandle === "capacidadePorProjeto" && (
                <Button
                    onClick={() =>
                        props.handleDados(
                            props.projetosSelecionados,
                            props.radioFiltrarPor,
                            props.dataInicial,
                            props.dataFinal,
                            props.clienteSelecionado,
                            props.clienteLabel,
                            props.liderSelecionado
                        )}
                >
                    Gerar
                </Button>
            )}

            {props.buttonHandle === "resultadosDoCliente" && (
                <Button
                    onClick={() =>
                        props.handleDados(
                            props.anoSelecionado,
                            props.dataInicial,
                            props.dataFinal,
                            props.clienteSelecionado,
                            props.radioPeriodo,
                            props.clienteSelecionadoNome,
                            props.radioFiltrarPor,
                            props.liderSelecionado,
                            props.liderSelecionadoNome
                        )}
                >
                    Gerar Relatório
                </Button>
            )}


        </>
    );
}